// Injected at build time from package.json via REACT_APP_VERSION (see the build script).
// The fallback is what a non-build context reports — jest does not run through the build script.
export default process.env.REACT_APP_VERSION || "0.0.0-dev";
